angular.module('procommTalentSearch').directive('selectOnClick', function () {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var focusedElement;
      element.on('click', function () {
        if (focusedElement != this) {
          this.select();
          focusedElement = this;
        }
      });
      element.on('blur', function () {
        focusedElement = null;
      });
    }
  };
});

angular.module('procommTalentSearch').controller('ProcommShareController', function ($scope, procommService, pcShareService) {
  var procommShareController = this;

  procommShareController.title = 'Share';
  $scope.title = 'Share2';

  console.log('share controller exists');

  $scope.state = pcShareService.state;

  $scope.demo = pcShareService.state.demo;

  $scope.talent = pcShareService.state.talent;

  $scope.playlist_slug = pcShareService.state.playlist_slug;

  if ($scope.playlist_slug) {
    $scope.demo.share_url = 'https://www.procommvoices.com/playlist/' + $scope.playlist_slug;
    $scope.share_url = 'https://www.procommvoices.com/playlist/' + $scope.playlist_slug;
  } else {
    $scope.demo.share_url = 'https://www.procommvoices.com/talent/' + $scope.talent.post_name + '?active_demo=' + $scope.demo.post_name;
    $scope.share_url = 'https://www.procommvoices.com/talent/' + $scope.talent.post_name + '?active_demo=' + $scope.demo.post_name;
  }

  // console.log('share state' , $scope.demo.share_url );

  $scope.emailFormActive = false;

  $scope.procommService = procommService;

  $scope.doSomething = function () {
    $scope.emailFormActive = !$scope.emailFormActive;
    console.log('do somethign!');
  };

  $scope.sendShareEmail = pcShareService.sendShareEmail;
});

angular.module('procommTalentSearch').controller('ProcommPlaylistController', function ($scope, procommService, procommPlaylistService, ngDialog) {
  var procommPlaylistController = this;

  $scope.procommService = procommService;

  $scope.state = procommPlaylistService.state;
  $scope.playlists = procommPlaylistService.state.playlists;

  $scope.demo = procommPlaylistService.state.demo;
  $scope.talent = procommPlaylistService.state.talent;
  $scope.state.createNewMode = false;
  $scope.message = '';
  $scope.message_error = false;

  // procommPlaylistService.state

  $scope.doSomething = function () {
    console.log('do somethign!');
  };

  $scope.createNewPlaylist = function () {
    $scope.state.createNewMode = true;
  };

  $scope.doCreateNew = function () {
    console.log('create new');

    $scope.state.newPlaylist.demo = $scope.demo;

    // $scope.newPlaylist.user = procommPlaylistService.user;
    console.log($scope.state.newPlaylist);
    procommPlaylistService.createPlaylist($scope.state.newPlaylist, $scope);
  };

  $scope.isDemoInPlaylistText = function (demo, playlist) {
    if (procommPlaylistService.isDemoInPlaylist(demo, playlist)) {
      return ' (Added)';
    } else {
      return '';
    }
  };
  $scope.isDemoInPlaylist = function (demo, playlist) {
    return procommPlaylistService.isDemoInPlaylist(demo, playlist);
  };

  $scope.isDemoInActivePlaylist = function (demo) {
    var test_playlist = procommPlaylistService.getPlaylistByID(procommPlaylistService.state.activePlaylist);

    return procommPlaylistService.isDemoInPlaylist(demo, test_playlist);
  };

  $scope.removeItemFromPlaylist = function () {
    console.log('remove item from playlist');
    console.log($scope.state.demo, $scope.state.activePlaylist);

    ngDialog.close();

    var response = procommPlaylistService.removeItemFromPlaylist($scope.state.demo, $scope.state.activePlaylist);

    response.then(function successCallback (response) {
      // this callback will be called asynchronously
      // when the response is available
      var newText = 'Removed from Playlist!';
      if ($scope.state.demo) {
        newText = $scope.state.demo.post_title + ' removed from playlist!';
      }

      swal({
        title: 'Item removed!',
        text: newText,
        timer: 2000,
        type: 'success'
      });
    },
    function errorCallback (response) {
      swal({
        title: 'Remove from Playlist Error!',
        text: 'Something went wrong - please try again.',
        type: 'error',
        showCancelButton: true
      }).then(procommPlaylistService.showDialog);

      // $scope.message = "Playlist Add failed - please try again.";
      // $scope.message_error = true;

      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.addItemToPlaylist = function () {
    console.log('Add item', $scope.state.demo, $scope.state.activePlaylist);
    ngDialog.close();

    var response = procommPlaylistService.addItemToPlaylist($scope.state.demo, $scope.state.activePlaylist);

    response.then(function successCallback (response) {
      // this callback will be called asynchronously
      // when the response is available
      var newText = 'Added to Playlist!';
      if ($scope.state.demo) {
        newText = $scope.state.demo.post_title + ' added to playlist!';
      }

      swal({
        title: 'Item added!',
        text: newText,
        timer: 2000,
        type: 'success'
      });
    },
    function errorCallback (response) {
      swal({
        title: 'Add to Playlist Error!',
        text: 'Something went wrong - please try again.',
        type: 'error',
        showCancelButton: true
      }).then(procommPlaylistService.showDialog);

      // $scope.message = "Playlist Add failed - please try again.";
      // $scope.message_error = true;

      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };
});
